import { Link } from "react-router-dom";
import "./NotFoundPage.css";

function NotFoundPage() {
  return (
    <div className="notfound-page page-enter">
      <div className="code-line" style={{ fontSize: 13 }}>
        <span className="syn-pink">throw new&nbsp;</span>
        <span className="syn-green">Error</span>
        <span className="syn-white">(</span>
        <span className="syn-orange">"404 — Page not found"</span>
        <span className="syn-white">);</span>
      </div>

      <div className="notfound-block">
        <span className="syn-comment">// The file you requested does not exist.</span><br />
        <span className="syn-comment">// Check the path and try again.</span>
      </div>

      <div className="code-line" style={{ fontSize: 13 }}>
        <span className="syn-yellow">navigate</span>
        <span className="syn-white">(</span>
        <Link to="/portfolio" className="syn-orange notfound-link">"/index.js"</Link>
        <span className="syn-white">);&nbsp;</span>
        <span className="syn-comment">// go home</span>
      </div>
    </div>
  );
}

export default NotFoundPage;
